import { IcDialog, IcTypography } from "@ukic/react";

/**
 * Controlled confirmation dialog using ICDS `ic-dialog` default controls.
 * Renders only the message; the Confirm/Cancel buttons are the dialog's own.
 */
export function ConfirmDialog({
  open,
  heading,
  message,
  destructive = false,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  heading: string;
  message: string;
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <IcDialog
      heading={heading}
      open={open}
      destructive={destructive}
      onIcDialogConfirmed={onConfirm}
      onIcDialogCancelled={onCancel}
      onIcDialogClosed={onCancel}
    >
      <IcTypography>{message}</IcTypography>
    </IcDialog>
  );
}
